import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

export const locales = routing.locales;
export const localePrefix = routing.localePrefix;

// Locale-aware <Link>/router: emits "/privacy" for pl (default, no prefix) and
// "/en/privacy", "/ua/privacy", … for the others. Mirrors middleware.ts.
// createNavigation (vs the legacy createSharedPathnamesNavigation) resolves the
// prefix during SSR, so crawlers see the final URL instead of "/pl/…" links
// that 307-redirect.
export const { Link, useRouter, usePathname, redirect, getPathname } =
  createNavigation(routing);
